module.exports = __webpack_public_path__ + "0604b1eb998d5a995916bc02c80e238f.MP3";